import React from 'react';
import PropTypes from 'prop-types';

const PlanetIcon = function PlanetIcon({ color = '#FFF', fontSize = 24 }) {
  return (
    <svg
      width={`${fontSize}`}
      height={`${fontSize}`}
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_45_334)">
        <path
          d="M21.5 0C9.632 0 0 9.632 0 21.5C0 33.368 9.632 43 21.5 43C33.368 43 43 33.368 43 21.5C43 9.632 33.368 0 21.5 0ZM4.3 21.5C4.3 17.3075 5.805 13.459 8.3205 10.4705L15.05 17.2V19.35C15.05 21.715 16.985 23.65 19.35 23.65V35.6685C19.35 36.249 19.5865 36.7865 19.9735 37.195L21.5 38.7C11.997 38.7 4.3 31.003 4.3 21.5ZM23.65 38.571V34.4L31.7125 22.317C32.0565 21.7795 32.25 21.156 32.25 20.5325V18.275C32.25 17.0925 31.2825 16.125 30.1 16.125H26.875L23.865 12.3625C23.048 11.352 21.8225 10.75 20.511 10.75H12.9V6.6005C15.437 5.1385 18.361 4.3 21.5 4.3C30.9815 4.3 38.7 12.0185 38.7 21.5C38.7 30.2505 32.121 37.496 23.65 38.571Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_45_334">
          <rect width="43" height="43" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

PlanetIcon.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.number,
};

export default PlanetIcon;
